@if (showInvoiceUpload) {
  <div class="mb-3 row">
    <label for="name" class="col-md-4 control-label text-start">
      {{'INVOICE'|translate}}
    *</label>
    <app-warranty-file-upload class="col-md-6" [warrantyId]="warrantyId" [formGroup]="formGroup">
    </app-warranty-file-upload>
  </div>
}
